import React, { Component } from 'react';
import limparUltimosHistoricosTrecho from '../../actions/trecho/limparUltimosHistoricosTrecho';
import { connect } from 'react-redux';
import $ from 'jquery';
import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { formatarReal } from '../../util/numberUtil';

export const Cabecalho = () => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(9, 1fr)', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', borderBottom: '2px solid #FF6A00', color: '#0F0F0F' }}>
        <div>Data e Hora</div>
        <div>Situação</div>
        <div>Usuário</div>
        <div>Cidade Destino</div>
        <div>Embarque</div>
        <div>Duração</div>
        <div>Quilometragem</div>
        <div>Taxa Emb.</div>
        <div>Pedágio</div>
    </div>
);

export class ModalHistoricoTrecho extends Component {

    fecharModal() {
        $('#modalHistoricoTrecho')
            .modal('hide');
        $('#modalHistoricoTrecho')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHistoricosTrecho();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => (
                <div key={`${historico.id}-${historico.dataEvento}`}
                     style={{ display: 'grid', gridTemplateColumns: 'repeat(9, 1fr)', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: '12px', alignItems: 'start' }}>
                    <div><Moment format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment></div>
                    <div>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</div>
                    <div>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</div>
                    <div>{historico.trechoDto.cidadeDestino ? historico.trechoDto.cidadeDestino.nomeComUf : ''}</div>
                    <div>{historico.trechoDto.pontoEmbarque}</div>
                    <div>{historico.trechoDto.duracao}</div>
                    <div>{historico.trechoDto.quilometragem}</div>
                    <div>{historico.trechoDto.taxaEmbarque ? formatarReal(historico.trechoDto.taxaEmbarque) : ''}</div>
                    <div>{historico.trechoDto.pedagio ? formatarReal(historico.trechoDto.pedagio) : ''}</div>
                </div>
            ))
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoTrecho' role='dialog'
                aria-labelledby='modalHistoricoTrecho' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">history</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">Histórico de Trechos</h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={() => this.fecharModal()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <Cabecalho />
                            {this.exibirHistoricos()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export const mapStateToProps = (state) => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosTrecho
    }
};

export default connect(mapStateToProps, {
    limparUltimosHistoricosTrecho
})(ModalHistoricoTrecho)